var _rect, _rect2, _path, _path2, _path3, _path4, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapAxes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#333333",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22609 16.2191L8 14L10.7739 16.2191C11.5121 16.8096 11.0945 18 10.1492 18H5.85078C4.9055 18 4.48795 16.8096 5.22609 16.2191Z",
    fill: "#333333",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19V18H7V19H9ZM17 25C17.5523 25 18 24.5523 18 24C18 23.4477 17.5523 23 17 23V25ZM7 19V20H9V19H7ZM12 25H17V23H12V25ZM7 20C7 22.7614 9.23858 25 12 25V23C10.3431 23 9 21.6569 9 20H7Z",
    fill: "#333333",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7739 15.7809L24 18L21.2261 15.7809C20.4879 15.1904 20.9055 14 21.8508 14L26.1492 14C27.0945 14 27.5121 15.1904 26.7739 15.7809Z",
    fill: "#333333",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13L23 14L25 14L25 13L23 13ZM15 7C14.4477 7 14 7.44771 14 8C14 8.55228 14.4477 9 15 9L15 7ZM25 13L25 12L23 12L23 13L25 13ZM20 7L15 7L15 9L20 9L20 7ZM25 12C25 9.23858 22.7614 7 20 7L20 9C21.6569 9 23 10.3431 23 12L25 12Z",
    fill: "#333333",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#333333",
    fillOpacity: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapAxes);
export default __webpack_public_path__ + "static/media/swap_axes.2be8550a.svg";
export { ForwardRef as ReactComponent };